import { useState } from 'react';

export default function MeetYourAgent() {
  const [imageLoaded, setImageLoaded] = useState(false);

  const credentials = [
    { icon: 'ri-shield-check-line', text: 'Licensed Life Insurance Agent' },
    { icon: 'ri-user-star-line', text: 'Independent Agent' },
    { icon: 'ri-award-line', text: 'NAIFA Member' },
    { icon: 'ri-time-line', text: '12 Years Experience' }
  ];

  const handleScheduleCall = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <section className="py-20 bg-[#FDF6F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-[#D97642]/15 text-[#D97642] text-[13px] font-semibold uppercase tracking-widest rounded-full border border-[#D97642]/25 mb-4">
            Your Agent
          </span>
          <h2 className="text-4xl font-bold text-[#1A3A52] mb-4">
            Meet Your Agent
          </h2>
          <p className="text-lg text-[#4A5568] max-w-2xl mx-auto">
            Working with a licensed, experienced professional who understands Indiana families
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Agent Photo */}
          <div className="relative">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/76c62141a49b49286375ae36f658c57b.jpg"
                alt="Benjamin Wright - Licensed Life Insurance Agent in Indianapolis, Indiana"
                title="Benjamin Wright — Licensed Life Insurance Agent Serving Indianapolis and All of Indiana"
                className="w-full h-full object-cover object-top"
                width={800}
                height={1000}
                loading="lazy"
              />
            </div>
            {/* Trust Badge Overlay */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-6 border-4 border-teal-500">
              <div className="text-center">
                <div className="text-4xl font-bold text-gray-900">12</div>
                <div className="text-sm font-semibold text-teal-600">Years Experience</div>
              </div>
            </div>
          </div>

          {/* Agent Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-[#1A3A52] mb-2">
                Benjamin Wright
              </h3>
              <p className="text-xl text-[#D97642] font-semibold mb-6">
                Licensed Life Insurance Specialist
              </p>
              
              <div className="prose prose-lg text-[#4A5568] space-y-4">
                <p>
                  My name is Benjamin Wright. I&apos;m a licensed life insurance agent right here in Indianapolis. &ldquo;Independent&rdquo; means I don&apos;t work for any single insurance company — I work for you. I compare prices from 20+ top companies like Mutual of Omaha, Prudential, Transamerica, North American, AIG, and Nationwide. Then I show you the best deal for your age, health, and budget.
                </p>
                <p>
                  In 12 years, I&apos;ve helped over 500 Indiana families. Young couples in Fishers getting their first life insurance policy. Retirees in Carmel turning their savings into a paycheck they can&apos;t outlive. Self-employed workers in Indianapolis who thought no one would cover them. I don&apos;t do one-size-fits-all. Every recommendation is built just for you.
                </p>
                <p className="text-lg font-semibold text-[#1A3A52] italic border-l-4 border-[#D97642] pl-4 py-2 bg-[#D97642]/5 rounded-r-lg">
                  &ldquo;An independent agent is a financial advantage. You get every company&apos;s best price — not just one company&apos;s only price.&rdquo;
                </p>
              </div>
            </div>

            {/* Credentials Grid */}
            <div className="grid grid-cols-2 gap-4">
              {credentials.map((credential, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-4 bg-white rounded-xl border border-gray-200 hover:border-[#D97642] hover:bg-[#FDF6F0] transition-all duration-300 shadow-sm"
                >
                  <div className="w-10 h-10 bg-[#D97642] rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${credential.icon} text-xl text-white`}></i>
                  </div>
                  <span className="text-sm font-semibold text-[#1A3A52] whitespace-nowrap">
                    {credential.text}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={handleScheduleCall}
                className="flex-1 bg-[#D97642] text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-[#C26638] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Schedule a Call
              </button>
              <a
                href="#contact"
                className="flex-1 bg-white text-[#1A3A52] px-8 py-4 rounded-xl font-semibold text-lg border-2 border-[#1A3A52] hover:bg-[#1A3A52] hover:text-white transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                Send a Message
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center gap-6 pt-4 border-t border-gray-200">
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-2xl text-[#D97642]"></i>
                <span className="text-sm text-[#4A5568] font-medium">Serving All of Indiana</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-2xl text-[#D97642]"></i>
                <span className="text-sm text-[#4A5568] font-medium">24/7 Support Available</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
